import {
    GET_USERS_REQUEST,
    GET_USERS_SUCCESS,
    GET_USERS_FAILURE,
    DELETE_USER_SUCCESS,
    DELETE_USER_FAILURE,
    CHANGE_USER_STATUS_SUCCESS,
    CHANGE_USER_STATUS_FAILURE,
    ADD_USER_REQUEST,
    ADD_USER_FAILURE,
    ADD_USER_SUCCESS,
    EDIT_USER_SUCCESS,
    EDIT_USER_FAILURE,
    GET_ALL_USERS_REQUEST,
    GET_ALL_USERS_SUCCESS,
    GET_ALL_USERS_FAILURE,
    GET_DENTIST_INFO_REQUEST,
    GET_DENTIST_INFO_SUCCESS,
    GET_DENTIST_INFO_FAILURE,
    GENERATE_RESET_PASSWORD_LINK_REQUEST,
    GENERATE_RESET_PASSWORD_LINK_SUCCESS,
    GENERATE_RESET_PASSWORD_LINK_FAILURE
} from './constants';

const initialState = {
    loading: true,
    loadingError: false,
    deletedUser: undefined,
    changeUser: undefined,
    dentistsList: [],
    allDentistsList: [],
    totalCount: undefined,
    addIsSuccess: undefined,
    editUser: undefined,
    user: [],
    dentistInfo: {},
    loadingDentist: false,
    resetPasswordLinkLoading: false,
    resetPasswordLinkSuccess: false,
    validation: {
        email: {valid: true, message: ''},
        first_name: {valid: true, message: ''},
        last_name: {valid: true, message: ''},
        username: {valid: true, message: ''},
        password: {valid: true, message: ''},
    }
};

const dentistsReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_USERS_REQUEST: {
            return Object.assign({}, state, {loading: false, addIsSuccess: undefined, editUser: undefined, deletedUser: undefined});
        }
        case GET_USERS_SUCCESS: {
            return Object.assign({}, state, {loading: false, loadingError: false, dentistsList: action.data.dentists, totalCount: action.data.totalCount, addIsSuccess: undefined, editUser: undefined, deletedUser: undefined});
        }
        case GET_USERS_FAILURE: {
            return Object.assign({}, state, {loading: false, loadingError: true, addIsSuccess: undefined, editUser: undefined, deletedUser: undefined});
        }
        case GET_ALL_USERS_REQUEST: {
            return Object.assign({}, state, {loading: false, addIsSuccess: undefined, editUser: null, deletedUser: null});
        }
        case GET_ALL_USERS_SUCCESS: {
            return Object.assign({}, state, {loading: false, loadingError: false, allDentistsList: action.data.dentists, totalCount: action.data.totalCount, addIsSuccess: undefined, editUser: null, deletedUser: null});
        }
        case GET_ALL_USERS_FAILURE: {
            return Object.assign({}, state, {loading: false, loadingError: true, addIsSuccess: undefined, editUser: null, deletedUser: null});
        }
        case DELETE_USER_SUCCESS: {
            return Object.assign({}, state, {loading: false, loadingError: false, dentistsList: action.data.dentists, totalCount: action.data.totalCount, deletedUser: true, addIsSuccess: undefined, editUser: undefined});
        }
        case DELETE_USER_FAILURE: {
            return Object.assign({}, state, {loading: false, loadingError: true, deletedUser: false, addIsSuccess: undefined, editUser: undefined});
        }
        case CHANGE_USER_STATUS_SUCCESS: {
            return Object.assign({}, state, {loading: false, loadingError: false, dentistsList: action.data.dentists, totalCount: action.data.totalCount, changeUser: true, addIsSuccess: undefined, editUser: undefined, deletedUser: undefined});
        }
        case CHANGE_USER_STATUS_FAILURE: {
            return Object.assign({}, state, {loading: false, loadingError: true, changeUser: true, addIsSuccess: undefined, editUser: undefined, deletedUser: undefined});
        }
        case ADD_USER_REQUEST:
            return state;
        case ADD_USER_SUCCESS:
            return Object.assign({}, state, {addIsSuccess: true, editUser: undefined, deletedUser: undefined});
        case ADD_USER_FAILURE:
            const uniqueFieldsAdd = Object.values(action.data.error.validationErrors);
            const validationAdd = JSON.parse(JSON.stringify(state.validation));
            uniqueFieldsAdd.forEach(item => {
                let text = (item === 'email') ? 'email address' : item;
                validationAdd[item]['valid'] = false;
                validationAdd[item]['message'] = (item === 'email' || item === 'username') ?
                    'This '+text+' has been taken. Please try another one.' :
                    'The field is required. Please fill in and try again.';
            });
            return Object.assign({}, state, { validation: validationAdd, addIsSuccess: false, editUser: undefined, deletedUser: undefined});
        case EDIT_USER_SUCCESS:
            return Object.assign({}, state, {loading: false, loadingError: true, changeUser: true, addIsSuccess: undefined, editUser: true, deletedUser: undefined});
        case EDIT_USER_FAILURE:
            const uniqueFieldsEdit = Object.values(action.data.error.validationErrors);
            const validationEdit = JSON.parse(JSON.stringify(state.validation));
            uniqueFieldsEdit.forEach(item => {
                let text = (item === 'email') ? 'email address' : item;
                validationEdit[item]['valid'] = false;
                validationEdit[item]['message'] = (item === 'email' || item === 'username') ?
                    'This '+text+' has been taken. Please try another one.' :
                    'The field is required. Please fill in and try again.';
            });
            return Object.assign({}, state, {loading: false, loadingError: true, changeUser: true, addIsSuccess: undefined, editUser: false, validation: validationEdit, deletedUser: undefined});

        case GET_DENTIST_INFO_REQUEST: {
            return Object.assign({}, state, {loadingDentist: true, dentistInfo: {}});
        }
        case GET_DENTIST_INFO_SUCCESS: {
            return Object.assign({}, state, {loadingDentist: false, dentistInfo: action.data});
        }
        case GET_DENTIST_INFO_FAILURE: {
            return Object.assign({}, state, {loadingDentist: false});
        }
        case GENERATE_RESET_PASSWORD_LINK_REQUEST: {
            return Object.assign({}, state, { resetPasswordLinkLoading: true, resetPasswordLinkSuccess: false });
        }
        case GENERATE_RESET_PASSWORD_LINK_SUCCESS: {
            return Object.assign({}, state, { resetPasswordLinkLoading: false, resetPasswordLinkSuccess: true });
        }
        case GENERATE_RESET_PASSWORD_LINK_FAILURE: {
            return Object.assign({}, state, { resetPasswordLinkLoading: false, resetPasswordLinkSuccess: false });
        }

        default: {
            return state;
        }
    }
};

export default dentistsReducer;



// WEBPACK FOOTER //
// ./src/containers/Layouts/Admin/Dentists/reducer.js